import i18n from '@/plugins/vue-i18n'

const TAG_TYPE_TO_PROPERTY = [
  { type: 'email', property: 'emails' },
  { type: 'user', property: 'userLogins' },
  { type: 'telegram', property: 'telegramContact' },
  { type: null, property: 'partnersTags' },
]

function splitTagsProperty(prop) {
  const oldArr = Array.isArray(prop.changeSet?.old) ? prop.changeSet.old : []
  const newArr = Array.isArray(prop.changeSet?.new) ? prop.changeSet.new : []
  const result = []

  TAG_TYPE_TO_PROPERTY.forEach(({ type, property }) => {
    const oldSubset = oldArr.filter(t => (t && t.type ? t.type : null) === type)
    const newSubset = newArr.filter(t => (t && t.type ? t.type : null) === type)
    const oldKey = oldSubset.map(t => t.title).sort().join(',')
    const newKey = newSubset.map(t => t.title).sort().join(',')
    if (oldKey === newKey) return
    result.push({
      id: `${prop.id}-${property}`,
      property,
      changeSet: {
        old: oldSubset.length ? oldSubset : null,
        new: newSubset.length ? newSubset : null,
        period: prop.changeSet?.period,
      },
    })
  })

  return result.length ? result : [prop]
}

function expandLogProperties(log) {
  const properties = log.properties?.length ? log.properties : [{ id: 'empty', property: null }]
  if (log.entity === 'partner_info') {
    return properties.flatMap(p => (p.property === 'tags' ? splitTagsProperty(p) : [p]))
  }
  return properties
}

function toPropertyFilter(value) {
  if (Array.isArray(value)) return value.filter(Boolean)
  return value ? [value] : []
}

function buildLogRow(log, prop, index, groupLength) {
  return {
    _id: `${log.id}-${prop.id || index}`,
    logId: log.id,
    createdAt: log.createdAt,
    action: log.action,
    entity: log.entity,
    entityId: log.entityId ?? null,
    entityTitle: log.entityTitle?.title || '',
    entityCountry: log.entityTitle?.country || '',
    authorName: log.createdBy?.fullName || log.createdBy?.email || i18n.tc('entityLog.systemUser'),
    authorId: log.createdBy?.id || null,
    property: prop.property,
    valueBefore: prop.changeSet?.old ?? null,
    valueAfter: prop.changeSet?.new ?? null,
    period: prop.changeSet?.period ?? null,
    isFirstInGroup: index === 0,
    groupLength,
  }
}

export function buildLogRows(list, propertyFilter) {
  const activeFilter = toPropertyFilter(propertyFilter)
  const rows = []

  list.forEach(log => {
    let properties = expandLogProperties(log)

    if (activeFilter.length) {
      properties = properties.filter(p => activeFilter.includes(p.property))
      if (!properties.length) return
    }

    properties.forEach((prop, index) => {
      rows.push(buildLogRow(log, prop, index, properties.length))
    })
  })

  return rows
}
